import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
    state: {
        employees: [],
        selectedEmployee: undefined
    },
    mutations: {

        setEmployees(state, payload) {
            state.employees = payload
        },

        setSelectedEmployee(state, payload) {
            state.selectedEmployee = payload
        },
    },
    actions: {

        async addNewEmployee ({ rootState }, payload) {
            let headerConfig = {
                headers: {
                    Authorization: `bearer ${rootState.User.userToken}`
                }
            }

            return await this.$http.post("/api/administrators/employees",payload, headerConfig)
                .then(response => {
                   return response;
                })
                .catch(error=>{
                    return error;
                });
        },

        async removeEmployee ({ rootState }, id) {

            let headerConfig = {
                headers: {
                    Authorization: `bearer ${rootState.User.userToken}`
                }
            };
            return await this.$http.delete(`api/administrators/employees/${id}`, headerConfig)
                .then(response => {
                    return response;
                })
                .catch(error => {
                    return error;
                });
        },

        async editEmployee({ rootState }, payload) {

            let headerConfig = {
                headers: {
                    Authorization: `bearer ${rootState.User.userToken}`
                }
            }
            console.log('indo',payload)
            return await this.$http.put(`/api/administrators/employees/${payload.id}`,payload, headerConfig)
                .then( response => {
                    return response;
                })
                .catch( error => {
                    return error;
                });
        },

        setSelectedEmployee({ commit }, payload) {
            commit('setSelectedEmployee', payload)
        },

        async loadEmployees({ commit, rootState }) {
            let headerConfig = {
                headers: {
                    Authorization: `bearer ${rootState.User.userToken}`
                }
            }
            return await this.$http.get("/api/administrators/employees", headerConfig)
                .then( response => {
                    if (response.data.employees){
                        console.log(response.data.employees)
                        commit("setEmployees", response.data.employees)
                    }
                    return response;
                })
                .catch(error => {
                    return error;
                });
        }

    },
    getters: {

        selectedEmployee (state){
            return state.selectedEmployee;
        },

        employees (state){
            return state.employees
        }
    }
};
